import alertGlobalState from '@/states/alertGlobalState';
import { useRecoilState } from 'recoil';
import React from 'react';
import Link from 'next/link';
import Button from '../atoms/Button';
import SystemErrorMessage from '../atoms/SystemErrorMessage';
/**
 * グローバルアラートダイアログ
 * @description
 * alertGlobalStateを更新することで、アラートダイアログを表示
 *
 * alertGlobalStateのパラメータ
 * - isOpen
 * - message
 * - type ("secure")
 * - closeAction
 */
const AlertDialogGlobal = () => {
  const [alertGlobal, setAlertGlobal] = useRecoilState(alertGlobalState);

  const onClose = () => {
    // 呼び出し元ごとの後処理があれば先に実行し、その後グローバル state を初期化する。
    if (alertGlobal.closeAction) {
      alertGlobal.closeAction();
    }

    setAlertGlobal((previousState) => ({
      ...previousState,
      isOpen: false,
      message: '',
      type: '',
      isInnerHtmlLayout: false,
      closeAction: () => {},
    }));
  };

  if (!alertGlobal.isOpen) {
    // モーダル終了後にスクロール抑止が残らないよう解除する。
    if (typeof window === 'object') {
      document.body.style.overflow = '';
    }
    return <span className='fn-overlay' data-testid='hidden' />;
  }

  if (typeof window === 'object') {
    document.body.style.overflow = 'hidden';
  }

  // Secure タイプだけは固定文面と設定変更導線を持つ専用 UI に切り替える。
  if (alertGlobal.type === 'secure') {
    return (
      <>
        <div className='m-modal js-modal is-modal-fade is-modal-show alert-dialog'>
          <div className='m-modal__inner'>
            <div className='m-modal__content align-center'>
              <div className='text-alert'>ご確認ください</div>
              <p>ご登録のクレジットカードの認証ができませんでした。</p>
              <p>
                ご登録の電話番号やメールアドレスがカードの最新情報と一致しているか、ご確認ください。
              </p>
              <p>※ご契約情報更新について</p>
              <p>
                ご契約情報 ＞ 契約者情報の変更 ＞{' '}
                <Link href='/mobile/contract/contractor/' onClick={onClose}>
                  電話番号更新
                </Link>
              </p>
              <p>
                ご契約情報 ＞ 契約者情報の変更 ＞{' '}
                <Link href='/mobile/contract/mail/' onClick={onClose}>
                  メールアドレスの登録・変更
                </Link>
              </p>
              <p>ご不明な点については、カード発行会社にお問い合わせください。</p>
            </div>
            <div className='m-modal__footer'>
              <div className='m-button align-center'>
                <Button variant='secondary' onClick={onClose}>
                  OK
                </Button>
              </div>
            </div>
          </div>
        </div>
        <span
          role='button'
          tabIndex={0}
          className='fn-overlay is-overlay-show'
          onClick={onClose}
          onKeyDown={onClose}
          aria-label='閉じる'
          data-testid='show'
        />
      </>
    );
  }

  // それ以外は共通エラー文面または HTML レイアウトをそのまま表示する。
  return (
    <>
      <div className='m-modal js-modal is-modal-fade is-modal-show alert-dialog'>
        <div className='m-modal__inner'>
          <div className='m-modal__content align-center'>
            <div className='text-alert'>ご確認ください</div>
            {!alertGlobal.isInnerHtmlLayout && <SystemErrorMessage message={alertGlobal.message} />}
            {alertGlobal.isInnerHtmlLayout && (
              <div dangerouslySetInnerHTML={{ __html: alertGlobal.message }} />
            )}
          </div>
          <div className='m-modal__footer'>
            <div className='m-button align-center'>
              <Button variant='secondary' onClick={onClose}>
                OK
              </Button>
            </div>
          </div>
        </div>
      </div>
      <span
        role='button'
        tabIndex={0}
        className='fn-overlay is-overlay-show'
        onClick={onClose}
        onKeyDown={onClose}
        aria-label='閉じる'
        data-testid='show'
      />
    </>
  );
};

export default AlertDialogGlobal;
